export { DotsIndicator } from './DotsIndicator';
